import { IOption, IComponent } from '../interfaces';
import { subjectOnChangeEventHandler } from './tree-select-onchange-handlers';
import { updatePreferredSubjectOptions, ActionTypes } from '../atoms/actions';
import { getDefaultStore } from 'jotai/vanilla';
import atoms from '../atoms';
import actions from '../atoms/actions';

enum TreeSelectIDs {
  SUBJECTS = '01eb3c55-0307-435f-88f2-10bcabba5649',
}

export interface TreeSelectOnChangeEventProps {
  id: string;
  originalValue: IOption[];
  value: IOption[];
}

const handlePreferredSubjectLogic = (selectedSubjects: IOption[]) => {
  const store = getDefaultStore();

  // 1. Update the available options for preferred subject
  updatePreferredSubjectOptions(selectedSubjects);

  // 2. Trigger validation for preferred subject component (after options are updated)
  setTimeout(() => {
    const components = store.get(atoms.component.list) as IComponent[];
    const preferredSubjectComponent = components.find(
      (comp) => comp.action === ActionTypes.preferred_subject,
    );

    if (preferredSubjectComponent) {
      // Use validate from actions to handle auto-selection and cleanup
      const validateAction = actions[ActionTypes.preferred_subject].validate;
      store.set(validateAction, preferredSubjectComponent.id);
    }
  }, 0); // Use setTimeout(0) to ensure options are updated first
};

const treeSelectOnChangeEventTracker = {
  [TreeSelectIDs.SUBJECTS]: subjectOnChangeEventHandler,
};

interface onSelect {
  (value: IOption[]);
}

export const treeSelectOnChangeEventWrapper = (
  id: string,
  originalValue,
  onSelect: onSelect,
  validate,
): onSelect => {
  const eventHandler = treeSelectOnChangeEventTracker[id];
  if (!eventHandler) return onSelect;

  return (value) => {
    eventHandler({ id, originalValue, value });
    onSelect(value);
    validate(id);

    if (id === TreeSelectIDs.SUBJECTS) {
      handlePreferredSubjectLogic(value);
    }
  };
};
